import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

import { getWirCreatedSectionKey } from './getSectionData';

export const getWirCreatedReactiveScopeData = (wir: WIR | null, countrySelect: string) => {
  const wirStep = getWirCreatedSectionKey(countrySelect);

  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : wirStep;
  const organiseKickOffMeeting = wir?.phases?.[phase]?.sections?.organiseKickOffMeeting;
  const initialRequestInformation = wir?.phases?.[phase]?.sections?.initialRequestInformation;

  return {
    phase,
    organiseKickOffMeeting,
    initialRequestInformation,
  };
};
